import React from 'react';
import { DataList, Loader } from 'commons-ui';
import { useStyletron } from 'baseui';
import { LIST_ENTITY_NAMES } from 'constant';
import useDashboardActions from 'pages/dashboard/useDashboardActions';
import { Button, KIND, SIZE, SHAPE } from 'baseui/button';

import { makeActionHandler } from '../../actions/handlers';
import { makeActionList } from '../../actions/list';
import useService from '../../utils/useService';
import { columnConfigs } from './listConfig';
import Filter from '../selectFilter';
import { listContainer, listItemButton } from '../selectFilter/style';

const PaymentPGFailureList: React.FC<{}> = () => {
	const {
		forceUpdate,
		showLoader,
		setShowLoader,
		jumpBack,
		jumpNext,
		pageNumber,
		getAllDowntimeData,
		handleFormSubmit,
		paymentGatewayList
	} = useService();
	const { getActionHandler, getActionList } = useDashboardActions(makeActionHandler, makeActionList, { setShowLoader });
	const actions = getActionList();
	const [css] = useStyletron();
	return (
		<>
			{showLoader && <Loader />}
			<Filter handleFormSubmit={handleFormSubmit} PG_NAME_OPTIONS={paymentGatewayList} />
			<div className={css(listContainer)}>
				<div title='nav' className={css(listItemButton)}>
					{pageNumber.currPage > 0 && (
						<Button
							kind={KIND.secondary}
							size={SIZE.compact}
							shape={SHAPE.pill}
							onClick={() => {
								jumpBack();
							}}>
							← Prev Page
						</Button>
					)}
					{pageNumber.nextPage !== null && (
						<Button
							kind={KIND.secondary}
							size={SIZE.compact}
							shape={SHAPE.pill}
							onClick={() => {
								jumpNext();
							}}>
							Next Page →
						</Button>
					)}
				</div>
			</div>
			<DataList
				fetchData={getAllDowntimeData}
				columnConfigs={columnConfigs}
				getActionHandler={getActionHandler}
				actions={actions}
				entity={LIST_ENTITY_NAMES.SCHEDULED_DOWNTIME}
				filterable={false}
				searchable={false}
				globalForceUpdate={forceUpdate}
				disablePagination={false}
				disablePaginationSelect={false}
			/>
		</>
	);
};

export default PaymentPGFailureList;
